import React, { useState, useEffect } from 'react'
import {
    InputBase,
    Grid,
    FormControlLabel,
    Checkbox,
    Button
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import SearchGrid from '../../components/table/SearchGrid';
import Breadcrums from '../../components/BreadCrums/breadcrums';
import TopSpacer from '../../components/Common/spacer/TopSpacer';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { PostDataAPI } from '../../Services/APIService';
import Loader from '../../components/Loader/Loader';
import { ActionDialog } from "../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../components/Message/Alert";
import AddWorker from './addWorker/AddWorker';
import { HealthcareTabletProgram, HealthcareTabletProgramApplyFor } from '../../components/Common/AppEnums';
import ActiveSocialWorker from '../../assets/img/icons/ActiveSocialWorker.svg';
import InactiveSocialWorker from '../../assets/img/icons/InactiveSocialWorker.svg';


function SocialWorker({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [editItem, setEditItem] = useState({});
    const [addWorkerDialog, setAddWorkerDialog] = useState(false);

    const statusBoxes = [
        {
            value: 'Active',
            status: 'Active',
            numbers: '00',
            icon: ActiveSocialWorker,
        },
        {
            value: 'InActive',
            status: 'InActive',
            numbers: '00',
            icon: InactiveSocialWorker,
        }

    ]

    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const handleActionClick = (key, item) => {
        switch (key) {

            case 'activate':
                updateSocialWorkerStatus(item, 'Active');
                break;
            case 'deactivate':
                updateSocialWorkerStatus(item, 'InActive');
                break;
            case 'delete':
                deleteSocialWorker(item)
                break;
            case 'edit':
                editWorkerDialog(item);
                break;
            default:
                break;
        }

    }

    const updateSocialWorkerStatus = (item, _status) => {
        var actionMessage = "Are you sure you want to activate this record?"
        if (_status == 'InActive') {
            actionMessage = "Are you sure you want to deactivate this record?";
        }
        showActionDialog(actionMessage, "confirm", function () {
            setIsLoading(true);
            var method = "fdnmcchromicconnect/updateSocialWorkerStatus";

            var params = { socialWorkerId: item.socialWorkerId, status: _status }

            PostDataAPI(method, params, true).then((result) => {
                setIsLoading(false);
                if (result.success) {
                    if (result.data) {
                        handleSuccessClose("Record status updated successfully.");
                        loadSocialWorkersGrid();
                    }
                    else {
                        showMessage("Error", "Error updating record, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }


            })
        });
    }

    const deleteSocialWorker = (item) => {
        showActionDialog("Are you sure you want to delete this record?", "confirm", function () {
            setIsLoading(true);
            var method = "fdnmcchromicconnect/deleteSocialWorker";

            PostDataAPI(method, item, true).then((result) => {
                setIsLoading(false);
                if (result.success) {
                    if (result.data) {
                        handleSuccessClose("Record deleted successfully.");
                        loadSocialWorkersGrid();
                    }
                    else {
                        showMessage("Error", "Error deleting record, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }


            })
        });
    }

    const editWorkerDialog = (item) => {
        setEditItem(item)
        setAddWorkerDialog(true);
    }
    const closeWorkerDialog = () => {
        setEditItem({})
        setAddWorkerDialog(false);
    }
    const handleSuccessClose = (message) => {
        closeWorkerDialog();
        showMessage("Success", message, "success", 3000);

        loadSocialWorkersGrid();
    }
    const AddWorkerDialog = () => {
        setAddWorkerDialog(true);
    }
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [socialWorkerData, setSocialWorkerData] = useState([]);
    const [filtereSocialWorkerData, setFiltereSocialWorkerData] = useState([]);


    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }

    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    const handleClearInput = (name) => {
        setValue('');
        handleDataGridUpdate();
    };

    const getHeaderCount = (status) => {
        var count = 0;
        if (status == 'Active') {
            count = socialWorkerData?.filter(t => t.status == 'Active').length
        } else if (status == 'InActive') {
            count = socialWorkerData?.filter(t => t.status == 'InActive').length
        }
        return count;
    }

    const [filteredStatus, setFilteredStatus] = useState([]);

    const handleStatusClick = (event, status) => {
        var lstStatus = filteredStatus;
        if (event.target.checked) {
            lstStatus.push(status);
        }
        else {
            lstStatus = lstStatus.filter(s => s != status)
        }
        setFilteredStatus(lstStatus);
        if (lstStatus.length > 0) {
            setFiltereSocialWorkerData(socialWorkerData.filter(o => lstStatus.some(s => s == o.status)));
        }
        else {
            setFiltereSocialWorkerData(socialWorkerData);
        }

        handleDataGridUpdate();
    }

    const ExportRecord = () => {
        let filteredData = [];
        const trimmedValue = searchFilter.trim()
        filteredData = [...filtereSocialWorkerData];
        filteredData = filteredData.filter(entry => {
            var hasValue = false;
            for (var prop in entry) {
                if (Object.prototype.hasOwnProperty.call(entry, prop)) {
                    hasValue = entry[prop]?.toString().toLowerCase().includes(trimmedValue.toLowerCase());
                    if (hasValue)
                        break;
                }
            }
            return hasValue;
        });
        if (filteredData && filteredData.length > 0) {
            const socialWorkerIds = filteredData.map(item => item.socialWorkerId);
            const postData = {
                applicationIds: socialWorkerIds,
                program: '',
                applicationType: '',
                type: ''
            };
            setIsLoading(true);
            PostDataAPI("fdnmcchromicconnect/exportSocialWorkers", postData).then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    window.open("." + result.data, "_blank");
                }
                else {
                    showMessage("Error", "No record exists", "error", 3000);
                }
            });
        }
        else {
            showMessage("Error", "No record exists", "error", 3000);
        }
    }

    const loadSocialWorkersGrid = () => {
        setIsLoading(true)
        var params1 = {
            ProgrameName: HealthcareTabletProgram.PalmBeachHCT
        };
        PostDataAPI("fdnmcchromicconnect/loadSocialWorkersGrid", params1).then((result) => {
            setIsLoading(false)
            if (result.success && result.data) {
                setSocialWorkerData(result.data);
                debugger
                if (filteredStatus.length > 0) {
                    setFiltereSocialWorkerData(result.data.filter(o => filteredStatus.some(s => s == o.status)));
                }
                else {
                    setFiltereSocialWorkerData(result.data);
                }
                handleDataGridUpdate()
            }
        })
    }


    useEffect(() => {
        loadSocialWorkersGrid();
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Social Worker"} isBack={true}></Breadcrums>
                    </Grid>
                </Grid>
            </div>

            <Grid container row className={classes.container}>

                <div className={classes.statusBoxContainer}>
                    {statusBoxes.map((item, i) => (
                        <>
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        onClick={(e) => { handleStatusClick(e, item.status) }}
                                    />
                                }
                                label={<>
                                    <div className={item.status == "Active" ? classes.statusBoxes + " " + "Active" :
                                        item.status == "InActive" ? classes.statusBoxes + " " + "InActive" :
                                            ''
                                    }>

                                        <div className={classes.statusBoxContent}>
                                            <div>
                                                <span style={{
                                                    fontSize: '30px',
                                                    color: 'white'
                                                }} >
                                                    {getHeaderCount(item.status)}
                                                </span>
                                                <h3>{item.value} </h3>
                                            </div>

                                            <img src={item.icon} width="70px" />
                                        </div>


                                    </div>
                                </>}
                            />
                        </>
                    ))}

                </div>

            </Grid>


            <Grid row className={classes.gridHeader}>
                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={() => ExportRecord()}> Export</Button>
                    <Button className={classes.changeBtn} onClick={() => AddWorkerDialog()}><AddCircleOutlineIcon style={{ marginRight: '6px' }} /> Add New</Button>
                </div>
                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                        autoComplete={'off'}
                    />
                </div>

            </Grid>



            <Grid row className={classes.container} >
                <SearchGrid columns="socialWorker"
                    list={filtereSocialWorkerData}
                    noRecordMsg="No record exists"
                    Icon={true}
                    isUpdate={isDataGridUpdate}
                    filter={searchFilter}
                    onActionClick={handleActionClick}
                    isTopPagination={true}
                />
            </Grid>

            {addWorkerDialog ?
                <AddWorker
                    dialogOpenClose={AddWorkerDialog}
                    handleClose={closeWorkerDialog}
                    handleSuccessClose={handleSuccessClose}
                    data={editItem}
                ></AddWorker>
                : ''}

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

        </>
    )

}

export default withSnackbar(SocialWorker);